/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { ContributorsResponse } from '@/client/models';
/**
 * ContributorsApi - axios parameter creator
 */
export const ContributorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get contributors information
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageContributorsGet: async (coverage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageContributorsGet', 'coverage', coverage)
            const localVarPath = `/coverage/{coverage}/contributors`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContributorsApi - functional programming interface
 */
export const ContributorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContributorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get contributors information
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageContributorsGet(coverage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContributorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageContributorsGet(coverage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.coverageCoverageContributorsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContributorsApi - factory interface
 */
export const ContributorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContributorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get contributors information
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageContributorsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<ContributorsResponse> {
            return localVarFp.coverageCoverageContributorsGet(coverage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContributorsApi - interface
 */
export interface ContributorsApiInterface {
    /**
     * 
     * @summary Get contributors information
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageContributorsGet(coverage: string, options?: RawAxiosRequestConfig): AxiosPromise<ContributorsResponse>;

}

/**
 * ContributorsApi - object-oriented interface
 */
export class ContributorsApi extends BaseAPI implements ContributorsApiInterface {
    /**
     * 
     * @summary Get contributors information
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageContributorsGet(coverage: string, options?: RawAxiosRequestConfig) {
        return ContributorsApiFp(this.configuration).coverageCoverageContributorsGet(coverage, options).then((request) => request(this.axios, this.basePath));
    }
}

